import { Component, OnInit } from '@angular/core';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { NgTemplateOutlet } from '@angular/common';
import { SliderComponent } from '../../../../shared/components/slider/slider.component';

@Component({
    selector: 'app-pwa-modal',
    templateUrl: './pwa-modal.component.html',
    styleUrls: ['./pwa-modal.component.scss'],
    imports: [SliderComponent, NgTemplateOutlet, TranslatePipe]
})
export class PwaModalComponent implements OnInit {

  public sliderConfig = {
    loop: true,
    slides: {
      perView: 1.5,
    },
    vertical: false,
    centered: true
  };

  public installSteps = [
    '/assets/img/pwa/1-step.png',
    '/assets/img/pwa/2-step.png',
    '/assets/img/pwa/3-step.png',
  ];

  constructor(
  ) {
  }

  ngOnInit(): void {
  }


}
